import React from "react";

import {
    Box,
    Typography,
    Grid,
    Container,
} from "@mui/material";

import { AmenIcons, Tribuja } from "../../assets";

const amenities = [
    {
        image: AmenIcons.clubhouse_icon,
        title: "Club House",
    },

    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/dumbbell.png",
        title: "Fitness Studio",
    },

    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/hall.png",
        title: "Banquet Hall",
    },

    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/theater.png",
        title: "Private Theater",
    },

    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/vip-room.png",
        title: "Party Lounge",
    },

    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/swimming-pool.png",
        title: "Terrace Pool",
    },

    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/dance.png",
        title: "Dance Room",
    },

    {
        image: AmenIcons.gym_icon,
        title: "Gymnasium",
    },
    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/yoga.png",
        title: "Yoga",
    },
    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/co-working.png",
        title: "Co-working Space",
    },
    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/discount.png",
        title: "Guest Rooms",
    },
    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/salon.png",
        title: "Salon & Spa",
    },
    {
        image: AmenIcons.jogging_icon,
        title: "Jogging Track",
    },
    {
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/stadium.png",
        title: "Amphitheater",
    },
    {
        image: AmenIcons.badminton_icon,
        title: "Badminton Court",
    },
    {
        image: AmenIcons.swimming_icon,
        title: "Swimming Pool",
    },
];

const Amenities = () => {
    return (
        <Box
            sx={{
                position: "relative",

                width: "100%",
                height: {xs:"auto",md:"100vh"},

                backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg.png")`,

                backgroundSize: "cover",

                backgroundPosition: "center",

                overflow: "hidden",
                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                py: { xs: 8, md: 6 },

                "&::before": {
                    content: '""',

                    position: "absolute",

                    inset: 0,

                    background:
                        "linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.6))",

                    zIndex: 1,
                },
            }}
        >
            <Container maxWidth="xl">
                <Box
                    sx={{
                        position: "relative",

                        zIndex: 2,
                    }}
                >
                    {/* TOP CONTENT */}

                    <Box
                        sx={{
                            textAlign: "center",

                            mb: {
                                xs: 7,
                                md: 10,
                            },
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{

                                fontFamily:"Luxury",
                                fontWeight: 500,

                                color: "#fff",

                                letterSpacing: "1px",

                                textTransform: "uppercase",

                                mb: 2,
                            }}
                        >
                            Amenities
                        </Typography>

                        <Box
                            sx={{
                                width: {
                                    xs: "120px",
                                    md: "180px",
                                },

                                height: "2px",

                                background:
                                    "linear-gradient(to right, transparent, #fff, transparent)",

                                mx: "auto",

                                mb: 3,
                            }}
                        />

                        <Typography

                            variant="body2"
                            sx={{
                                maxWidth: "760px",

                                mx: "auto",

                                color: "rgba(255,255,255,0.75)",

                                // fontSize: {
                                //   xs: "14px",
                                //   md: "16px",
                                // },

                                lineHeight: 1.9,

                                letterSpacing: "0.5px",
                            }}
                        >
                            Thoughtfully curated amenities designed
                            for luxury, wellness, recreation, and
                            elevated community living.
                        </Typography>
                    </Box>

                    {/* IMAGE LAYOUT */}

                    <Grid
                        container
                        rowSpacing={5} // DECREASE ROW SPACE
                        columnSpacing={{
                            xs: 1,
                            md: 0.5,
                        }}
                        // justifyContent="center"
                        sx={{
                            // maxWidth: "1250px",
                            // mx: "auto",
                            display: "flex",

                            // flexDirection: "column",

                            alignItems: "center",

                            justifyContent: "center",
                        }}
                    >
                        {amenities.map((item, index) => (
                            <Grid
                                item
                                xs={4}
                                sm={3}
                                md={1.8}
                                key={index}
                            >
                                <Box
                                    sx={{
                                        display: "flex",

                                        flexDirection: "column",

                                        alignItems: "center",

                                        justifyContent: "center",

                                        textAlign: "center",

                                        position: "relative",

                                        transition: "0.4s ease",

                                        cursor: "pointer",

                                        "&:hover": {
                                            transform:
                                                "translateY(-10px)",
                                        },
                                    }}
                                >
                                    {/* IMAGE CIRCLE */}

                                    <Box
                                        sx={{
                                            width: {
                                                xs: 78,
                                                md: 60,
                                            },

                                            height: {
                                                xs: 78,
                                                md: 60,
                                            },

                                            borderRadius: "50%",

                                            display: "flex",

                                            justifyContent: "center",

                                            alignItems: "center",

                                            position: "relative",

                                            mb: 1.8,

                                            background:
                                                "rgba(255,255,255,0.06)",

                                            backdropFilter: "blur(10px)",

                                            border:
                                                "1px solid rgba(255,255,255,0.12)",

                                            transition: "0.4s ease",

                                            "&::before": {
                                                content: '""',

                                                position: "absolute",

                                                inset: "-8px",

                                                borderRadius: "50%",

                                                border:
                                                    "1px solid rgba(255,255,255,0.08)",

                                                opacity: 0,

                                                transition: "0.4s ease",
                                            },

                                            "&:hover": {
                                                background:
                                                    "rgba(255,255,255,0.12)",

                                                boxShadow:
                                                    "0 10px 35px rgba(255,255,255,0.12)",
                                            },

                                            "&:hover::before": {
                                                opacity: 1,
                                            },
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={item.image}
                                            alt={item.title}
                                            sx={{
                                                width: {
                                                    xs: 34,
                                                    md: 28,
                                                },

                                                height: {
                                                    xs: 34,
                                                    md: 28,
                                                },

                                                objectFit: "contain",

                                                filter:
                                                    "brightness(0) invert(1)",
                                            }}
                                        />
                                    </Box>

                                    {/* TITLE */}

                                    <Typography
                                        sx={{
                                            color: "#fff",

                                            fontSize: {
                                                xs: "14px",
                                                md: "14px",
                                            },

                                            fontWeight: 600,

                                            letterSpacing: "0.5px",

                                            transition: "0.3s ease",

                                            "&:hover": {
                                                color: "#d9d9d9",
                                            },
                                        }}
                                    >
                                        {item.title}
                                    </Typography>

                                    {/* SMALL LINE */}

                                    {/* <Box
                    sx={{
                      width: "40px",

                      height: "1px",

                      background:
                        "rgba(255,255,255,0.3)",

                      mt: 2,

                      transition: "0.4s ease",
                    }}
                  /> */}
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default Amenities;